<template>
  <div class="prices" :class="mode">
    <template v-if="product && (product.onSale || product.onClearance)">
      <span class="newPrice"> {{ price.finalFormatted }} <span v-if="price.pair">pair</span> </span>
      <span class="originalPrice">{{ price.priceFormatted }}</span>
    </template>
    <template v-else-if="product">
      <span class="regularPrice"> {{ price.finalFormatted }} <span v-if="price.pair">pair</span> </span>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'Price',
  props: {
    mode: {
      required: true,
      validator(value) {
        return ['top', 'desktop', 'mobile'].includes(value);
      },
    },
  },
  computed: {
    ...mapState('product', ['product']),
    ...mapGetters('product', ['price']),
  },
};
</script>

<style lang="scss">
@import '~@article/pixel/dist/style/variables';

.prices {
  &.top {
    display: inline-block;
    line-height: 12px;
    margin-right: 20px;

    .originalPrice {
      font-size: var(--font-size-14);
      text-decoration: line-through;
    }
    .newPrice {
      font-size: 1.4em;
      line-height: 28px;
      color: var(--accent-color);
    }
    .regularPrice {
      color: var(--coral);
      font-size: 1.4em;
    }
  }

  &.desktop {
    display: inline-block;
    line-height: 40px;
    text-align: right;
    margin-right: 20px;
    .originalPrice {
      margin-right: 14px;
      font-size: var(--font-size-16);
      text-decoration: line-through;
      color: var(--grey-medium);
    }
    .newPrice {
      float: right;
      font-size: 1.5em;
    }
    .regularPrice {
      font-size: 1.5em;
      color: var(--coral);
    }
  }
}
</style>
